/**
 * Consume an NDJSON stream from POST /api/generate/stream.
 * onEvent is called for each parsed line: {type, ...}
 * Returns a promise that resolves when the stream finishes.
 */
import { API_BASE } from "@/lib/api";

export async function streamGenerate({ content, formats, use_brand_voice, brand_voice_id, template_id, onEvent, signal }) {
  const token = localStorage.getItem("ps_token");
  const res = await fetch(`${API_BASE}/generate/stream`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({ content, formats, use_brand_voice, brand_voice_id, template_id }),
    signal,
  });

  if (!res.ok) {
    let detail = "Stream request failed";
    try { const j = await res.json(); detail = j.detail || detail; } catch { /* ignore */ }
    const err = new Error(detail);
    err.status = res.status;
    err.detail = detail;
    throw err;
  }

  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";

  while (true) {
    const { value, done } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    let idx;
    while ((idx = buffer.indexOf("\n")) !== -1) {
      const line = buffer.slice(0, idx).trim();
      buffer = buffer.slice(idx + 1);
      if (!line) continue;
      try {
        const evt = JSON.parse(line);
        onEvent(evt);
      } catch {
        // ignore malformed line
      }
    }
  }
  // Flush any remaining
  if (buffer.trim()) {
    try { onEvent(JSON.parse(buffer.trim())); } catch { /* ignore */ }
  }
}
